export default {
  titles: {
    default: 'Przypomnienie o zaplanowanym zamówieniu!',
    external_delivery: 'Kierowca przypisany!',
  },
  labels: {
    pickup: 'Odbiór: {{time}}',
    preparation_time: 'Czas przygotowania: {{time}} min',
  },
  buttons: {
    confirm: 'Zacznij przygotowywać teraz',
    print_and_confirm: 'Drukuj i zacznij przygotowywać teraz',
  },
  toasts: {
    something_went_wrong: 'Coś poszło nie tak, spróbuj ponownie',
  },
};
